<template>
  <div class="character-container">
    <div id="character" class="character" @click="show">
      <div class="character-background">
        <div class="character-background-shadow">
          <img
            class="character-image"
            loading="lazy"
            :src="fullImage"
            :alt="nameJp"
            :class="`character-image-${keyName}`"
          />
        </div>
      </div>
      <p class="character-name character-name-jp">{{ nameJp }}</p>
      <p class="character-name character-name-en">{{ nameEn }}</p>
      <a :href="`https://twitter.com/${twitterId}`" target="_blank" rel="noopener" @click.stop="">
        <img
          class="character-twitter-logo"
          loading="lazy"
          src="../../assets/images/Twitter_Logo_Blue.png"
          alt="Twitterのロゴ"
        />
      </a>
    </div>
    <modal
      :name="`character-modal-${keyName}`"
      :adaptive="true"
      :reset="true"
      :width="'90%'"
      :height="'95%'"
      :max-width="936"
      :max-height="700"
      :styles="modalStyles"
    >
      <characterModal v-bind="$props"></characterModal>
    </modal>
    <modal
      :name="`character-modal-${keyName}-mobile`"
      :adaptive="true"
      :reset="true"
      :width="'90%'"
      :height="'95%'"
      :styles="modalStyles"
    >
      <characterModalMobile :key-name="$props.keyName"></characterModalMobile>
    </modal>
  </div>
</template>

<script>
import characterModal from './characterModal'
import characterModalMobile from './characterModalMobile'

export default {
  name: 'Character',
  components: {
    characterModal,
    characterModalMobile
  },
  props: {
    keyName: String,
    nameJp: String,
    nameEn: String,
    fullImage: String,
    twitterId: String,
    gallery1: String,
    gallery2: String,
    gallery3: String,
    age: String,
    birthday: String,
    description: String
  },
  data() {
    return {
      modalStyles: {
        background: 'none',
        'border-radius': '0',
        'box-shadow': 'none'
      }
    }
  },
  methods: {
    show() {
      if (window.innerWidth > 980) {
        this.$modal.show(`character-modal-${this.keyName}`)
      } else {
        this.$modal.show(`character-modal-${this.keyName}-mobile`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../stylesheets/variables';

.character-container {
  position: relative;
  width: 480px;
  height: 500px;
}

.character {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(40deg, transparent 30px, $white calc(30px + 1px)),
    linear-gradient(0deg, $white 0, $white 0), linear-gradient(220deg, transparent 30px, $white calc(30px + 1px)),
    linear-gradient(0deg, $white 0, $white 0);
  background-position: bottom left, bottom right, top right, top left;
  background-size: 50% 50%;
  background-repeat: no-repeat;
  cursor: pointer;

  &-background {
    z-index: 1;
    position: relative;
    height: 64%;
    top: 11.1%;
    background-color: $light-green;
    transform: skewY(12.9deg);
    overflow: hidden;

    &-shadow {
      height: 100%;
      box-shadow: 0 4px 4px 0 rgba($color: $black, $alpha: 0.1) inset,
        0 -4px 4px 0 rgba($color: $black, $alpha: 0.1) inset;
    }
  }

  &-image {
    z-index: -1;
    position: relative;
    width: 100%;
    object-fit: cover;

    &-tsumugi {
      transform: skewY(-12.9deg) scale(1.9);
      padding-top: 41.6%;
    }
    &-musha {
      transform: skewY(-12.9deg) scale(0.9);
      height: 199%;
      margin-left: 3.5%;
    }
  }

  &-name {
    &-jp {
      color: $normal-bg;
      margin: 12.5% 0 0 4.2%;
    }

    &-en {
      color: $light-bg;
      font-size: 22px;
      margin: 0 0 0 13.5%;
    }
  }

  &-twitter-logo {
    position: absolute;
    width: 12.5%;
    right: 0;
    bottom: 0;
  }
}

@media screen and (max-width: $break-point) {
  .character-container {
    width: 85.3%;
    max-width: 480px;
    height: auto;
    margin: 0 auto 23px;
  }

  .character-container::after {
    content: '';
    display: block;
    padding-top: 104%;
  }

  .character {
    &-name {
      &-jp {
        font-size: calc((5 / 94) * 100vw - (183 / 94) * 1px);
      }

      &-en {
        font-size: calc((2 / 47) * 100vw - (92 / 47) * 1px);
      }
    }
  }
}

@media screen and (min-width: 563px) {
  .character {
    &-name {
      &-jp {
        font-size: 28px;
      }

      &-en {
        font-size: 22px;
      }
    }
  }
}
</style>
